import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { MyGoalsGoalsPageDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { NewGoalModal } from 'modules/goals/components/NewGoalModal'
import GoalConfigTable from 'modules/goals/components/Table'
import goalsConfig from 'modules/goals/store/collections/goalsconfig'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const GoalsPage = () => {
  const { access } = useCurrentSession()
  const [showNewGoalModal, setShowNewGoalModal] = useState(false)

  const { loading: loadingAsyncData } = useAsyncData(
    () =>
      goalsConfig.fetch({
        data: {
          owner_id: access.id,
        },
      }),
    []
  )

  const { data, loading: loadingGraphQl } = useQuery(MyGoalsGoalsPageDocument, {})
  const canCreateGoalConfig = data?.apiCore._policies.accessGoalsConfigCreate.can ?? false
  const canSeeClockedIn = data?.attendance._policies.companySeeClockedIn.can ?? false

  const loading = loadingAsyncData || loadingGraphQl

  return (
    <ResponsivePage.Body
      error={null}
      loading={loading}
      actions={{}}
      showHeader
      header={{
        title: i18n.t('goals.index.title'),
        description: i18n.t('goals.index.description'),
        illustration: 'performance_management',
      }}
      widget={
        canCreateGoalConfig && (
          <Button iconName="add" onClick={() => setShowNewGoalModal(true)}>
            {i18n.t('surveys.index.actions.new_goal')}
          </Button>
        )
      }
    >
      <GoalConfigTable canSeeClockedIn={canSeeClockedIn} />
      {showNewGoalModal && <NewGoalModal onClose={() => setShowNewGoalModal(false)} />}
    </ResponsivePage.Body>
  )
}

export default GoalsPage
